import { Radio } from '@mantine/core';
import * as FormsTypes from '../FormsTypes';
import { isValueABoolean } from '../utils/FormsUtils';
export default function SingleInput({ options }: { options: FormsTypes.RenderFormElementOptions }) {
    const { inputRef, model } = options;

    return (
        <Radio
            required={model.required}
            id={model.id}
            defaultChecked={isValueABoolean(model.value) ? model.value : undefined}
            label={model.label}
            ref={inputRef}
            name={model.radioGroupName}
        />
    );
}
